The way to present the response choice selection.

Currently, three codes are defined:

- `SingleChoice` indicates a question that expects a single preferred response choice.

  A radio group or dropdown may be used.

- `MultiChoice` indicates a question that expects multiple preferred response choices.

  A checkbox group may be used.

- `Range` indicates a question that expects two response choices representing the minimum and maximum preferred values.

  A set of two dropdowns may be used.
